import { ReactComponent as autoStoriesIcon } from '../../../../../../icons/auto_stories.svg';
import React, { useContext, useState } from "react";
import './addDocumentProposalModal.scss';
import { apiContext } from '../../../../../../contexts/apiContext';
import { AddDocumentProposalModalProps } from './types/addDocumentModalProps';
import { ButtonFieldProps } from '../../../../../../components/buttonField/types/buttonFieldProps';
import { classNameBtn } from '../../../../../../components/shared/button/types/buttonProps';
import { stylizationVerticalAlign } from '../../../../../../components/shared/stylization';
import { FormFieldProps } from '../../../../../../components/formField/types/formFieldProps';
import { notifyError, notifySuccess } from '../../../../../../components/snackbar/snackbar';
import ButtonField from '../../../../../../components/buttonField/buttonField';
import Modal from '../../../../../../components/modalWindow/modal';
import FormField from '../../../../../../components/formField/formField';
import KrFormContext, { DocumentsAttributes } from '../../../../../../contexts/krFormContext';
import { addDocumentDictProposal } from '../../../../../../services/dictionariesService/dictionariesService';
import { AddDocumentDictProposalProps } from '../../../../../../services/dictionariesService/types/dictionariesServiceProps';
import { configValidation, createConfigValidation } from "../../../../../../helpers/validation/validation";
import AuthContext from '../../../../../../contexts/authContext';
import { setDictProposition } from '../../../../../../database/indexedDbReadWrite';

const AddDocumentProposalModal = (props: AddDocumentProposalModalProps) => {
    const api = useContext(apiContext);
    const { local } = useContext(KrFormContext);
    const { username, onlineMode } = useContext(AuthContext);
    const [newDocument, setNewDocument] = useState<DocumentsAttributes>({});
    const [checkValidationFlag, setCheckValidationFlag] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    // Inputs    
    const getInputProps = (labelName: string, inputPlaceholder: string, inputId: string, type: string, value?: string | number | null, configValidation?: configValidation): FormFieldProps => {
        return {
            labelName: labelName,
            inputPlaceholder: inputPlaceholder,
            type: type,
            pristine: true,
            setValue: (event: any) => onChangeInput(event, inputId),
            style: {
                paddingTop: "10px"
            },
            className: "empty",
            value: value === null ? "" : value,
            configValidation: configValidation,
            validationError: checkValidationFlag,
            disabled: loading
        };
    }

    const onChangeInput = (event: any, id: any) => {       
        setNewDocument((prevData) => ({...prevData, [id]: event}));
    }
    
    // 'Add proposal' button
    const getBtnProps = (title: string, btnClass: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${classNameBtn.Btn} ${btnClass} body-txt-medium`
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
        };
    }

    const checkValidation = () => {
        setCheckValidationFlag(true);
        if (newDocument.autorzy === undefined || newDocument.autorzy === null || newDocument.autorzy === "") return false;
        if (newDocument.tytul === undefined || newDocument.tytul === null || newDocument.tytul === "") return false;
        if (newDocument.rok === undefined || newDocument.rok === null) return false;
        if (newDocument.nazwA_FIRMY === undefined || newDocument.nazwA_FIRMY === null || newDocument.nazwA_FIRMY === "") return false;
        if (newDocument.tytul !== undefined && newDocument.tytul.length > 250) return false;
        if (newDocument.autorzy !== undefined && newDocument.autorzy.length > 250) return false;
        if (newDocument.nazwA_FIRMY !== undefined && newDocument.nazwA_FIRMY.length > 250) return false;
        return true;
    }

    const handleAddDocumentProposal = () => {        
        if (checkValidation()) {
            let addDocumentProposalProps: AddDocumentDictProposalProps = {
                newDocument: newDocument,
                apiBase: api.apiUrl + api.apiVersion
            }
    
            setLoading(true);
            if (local && !onlineMode) {
                setDictProposition(username, addDocumentProposalProps, "document").then((response) => {
                    notifySuccess({ message: "Dodano propozycję dokumentu, propozycja zostanie zsynchronizowana po przejściu na tryb online" });
                    close();
                }).catch(() => {
                    notifyError({ message: "Dodanie propozycji dokumentu zakończone niepowodzeniem" });
                }).finally(() => {
                    setLoading(false);
                });
            }
            else{
                addDocumentDictProposal(addDocumentProposalProps)
                .then(() => {   
                    notifySuccess({ message: "Dodano propozycję dokumentu" });    
                    close();
                })
                .catch(() => {
                    notifyError({ message: "Dodanie propozycji dokumentu zakończone niepowodzeniem" });               
                })
                .finally(() => {
                    setLoading(false);
                });
            }
        }     
    }

    const close = () => {
        props.onClose();
        refocus();
    }
    
    const refocus = () => {
        if (props.refocus) props.refocus();
    }

    const actionBtns = [
        <ButtonField key={1}{...getBtnProps("Anuluj", classNameBtn.LargeSecondary, () => { close() })}></ButtonField>,
        <ButtonField key={2}{...getBtnProps("Wyślij propozycję dokumentu", classNameBtn.Large, () => { handleAddDocumentProposal() })}></ButtonField>
    ]

    return (<Modal
        title={"Dokumenty"}
        titleIcon={autoStoriesIcon}
        iconClass='titleIcon'
        width={'1100px'}
        height={'585px'}
        actionBtns={actionBtns}
        onClose={close}
        loading={loading}> 
        <div className='addDocumentProposalModalWrapperOuter'>
                <FormField {...getInputProps("Tytuł", "Wpisz tytuł dokumentu", "tytul", "text", newDocument.tytul, createConfigValidation("dokumenty_Tytul"))}/>
                <div className='addDocumentProposalModalWrapperInner'>                        
                    <div>
                        <FormField {...getInputProps("Autorzy", "Wpisz pełne nazwiska i imiona autorów, np. Kowalski Jan, Kowalska Anna", "autorzy", "text", newDocument.autorzy, createConfigValidation("dokumenty_Tytul"))}/>
                        <FormField {...getInputProps("Nazwa firmy", "Wpisz nazwę firmy", "nazwA_FIRMY", "text", newDocument.nazwA_FIRMY, createConfigValidation("dokumenty_Tytul"))}/>
                        <FormField {...getInputProps("Nazwa archiwum", "Wpisz nazwę archiwum", "nazwA_ARCHIWUM", "text", newDocument.nazwA_ARCHIWUM)}/>
                    </div>
                    <div>
                        <FormField {...getInputProps("Rok", "Wpisz rok dokumentu", "rok", "number", newDocument.rok, createConfigValidation("onlyRequired"))} onlyDigits={true}/>
                        <FormField {...getInputProps("Numery inwentarzowe", "Wpisz numery inwentarzowe dokumentu", "numerY_INW", "text", newDocument.numerY_INW)}/>
                    </div>
                    
                    {/* <div>
                        <FormField {...getInputProps("Rok", "Wpisz rok dokumentu", "rok", "number", newDocument.rok, createConfigValidation("onlyRequired"))}/>
                        <FormField {...getInputProps("Nazwa firmy", "Wpisz nazwę firmy", "nazwA_FIRMY", "text", newDocument.nazwA_FIRMY, createConfigValidation("onlyRequired"))}/>      
                        <FormField {...getInputProps("Adres firmy", "Wpisz adres firmy", "adreS_FIRMY", "text", newDocument.adreS_FIRMY)}/>
                    </div>
                    <div>
                        <FormField {...getInputProps("Autorzy", "Wpisz pełne nazwiska i imiona autorów, np. Kowalski Jan, Kowalska Anna", "autorzy", "text", newDocument.autorzy, createConfigValidation("onlyRequired"))}/>
                        <FormField {...getInputProps("Nazwa archiwum", "Wpisz nazwę archiwum", "nazwA_ARCHIWUM", "text", newDocument.nazwA_ARCHIWUM)}/>
                        <FormField {...getInputProps("Adres archiwum ", "Wpisz adres archiwum", "adreS_ARCHIWUM", "text", newDocument.adreS_ARCHIWUM)}/>
                        
                    </div>
                    <div>
                        <FormField {...getInputProps("Numery inwentarzowe", "Wpisz numery inwentarzowe dokumentu", "numerY_INW", "text", newDocument.numerY_INW)}/>
                        <FormField {...getInputProps("Mapa 1:10 000", "Wpisz nazwę mapy 1:10 000", "mapA10", "text", newDocument.mapA10)}/>
                        <FormField {...getInputProps("Mapa 1:50 000", "Wpisz nazwę mapy 1:50 000", "mapA50", "text", newDocument.mapA50)}/>   
                    </div>        */}
                </div>
                {/* <FormField {...getInputProps("Uwagi", "Wpisz dodatkowe uwagi", "uwagi", "text", newDocument.uwagi)}/>   */}
            </div>    
    </Modal>);
};

export default AddDocumentProposalModal;